export default "__VITE_ASSET__DFOMzsEC__"